import { Button, Chip, IconButton, Stack } from "@mui/material";
import { Localized } from "@fluent/react";
import SyncIcon from '@mui/icons-material/Sync';
import { Dispatch, SetStateAction } from "react";
import { FilterOptions } from "../documents/utils/types";
import { defUserRequestsFilters } from "./helper";
import { StandardFilterMenu } from "../documents/utils/StandardFilterMenu";

export interface UserRequestFilters {
    statusOptions: FilterOptions[];
}

interface UserRequestsFilterPanelProps {
    filters: UserRequestFilters
    onFilterChange: Dispatch<SetStateAction<UserRequestFilters>>
    reload: () => void
}

export const UserRequestsFilterPanel = ({ filters, onFilterChange, reload }:UserRequestsFilterPanelProps) => {    
    const updateOption = (type: string, name:string) => {
        if(type === "status") {
            onFilterChange(prevFilters => ({
                ...prevFilters,
                statusOptions: prevFilters.statusOptions.map(item =>
                    item.uniqueName === name ? { ...item, selected: !item.selected } : item
                )
            }))
        }
    }

    const handleRefreshClick = () => {
        reload()
    }

    const handleClearFiltersClick = () => {
        onFilterChange(prevFilters => ({ 
            date: { from: "all", to: "all" },
            statusOptions: prevFilters.statusOptions.map(item => ({
                ...item,
                selected: false
            }))
        }));

        onFilterChange(defUserRequestsFilters)
    }

    return (
        <>
            <Stack sx={{ paddingBottom: 1 }}>
                <Stack direction="row" spacing={1} flexWrap="wrap">
                    <StandardFilterMenu label="Status" multiple options={filters.statusOptions} onUpdate={(name) => updateOption("status", name)}></StandardFilterMenu>
                    <IconButton
                        onClick={handleRefreshClick}>
                        <SyncIcon />
                    </IconButton>
                </Stack>
                <Stack direction="row" spacing={1} flexWrap="wrap" alignItems="center">
                    {filters.statusOptions.filter(f => f.selected).map((option) =>
                        <Chip label={<span><strong>Status: </strong>{option.translationCode ? <Localized id={option.translationCode}>{option.name}</Localized> : option.name}</span>} size="small" onDelete={() => updateOption("status", option.uniqueName)}/>
                    )}
                    {filters.statusOptions.some(o => o.selected) ? <Button size="small" variant="text" onClick={handleClearFiltersClick}>
                        <Localized id="filters-clear-all-filters">_Wyczyść filtry</Localized>
                    </Button> : null}
                </Stack>
            </Stack>
        </>
    )
}
